import { CreditsHeader } from '../components/Credits';


import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect, Fragment } from 'react';
import {
  FaSearch, FaUserCircle, FaBars, FaTimes, FaNewspaper,
  FaLaptopCode, FaStethoscope, FaUniversity, FaBullhorn, FaChartLine, FaHeadset,
  FaIndustry, FaTruck, FaHotel, FaGraduationCap, FaUsers, FaHardHat, FaBriefcase, FaMapMarkerAlt,
  FaFileAlt, FaMicrophone, FaQuestionCircle,  FaClock, FaUserGraduate, FaFileSignature, FaMoon, FaHome, FaLaptopHouse,
} from 'react-icons/fa';
import api, { BACKEND_URL } from '../api/axios';
import NotificationBell from './NotificationBell';
import planbLogo from '../assets/planbjobs-logo.png';
import landingData from '../seo/landingData';

// const BACKEND_URL = 'http://127.0.0.1:8000';
import InstallAppButton from '../components/InstallAppButton';



const companyLocations = [
  { label: 'Bengaluru', full: 'Bengaluru' },
  { label: 'Hyderabad', full: 'Hyderabad' },
  { label: 'Mumbai', full: 'Mumbai' },
  { label: 'Pune', full: 'Pune' },
  { label: 'Chennai', full: 'Chennai' },
  { label: 'Delhi NCR', full: 'Delhi' },
];

const jobsInDemand = [
  { label: 'Full time jobs', to: '/full-time-jobs', Icon: FaBriefcase },
  { label: 'Part time jobs', to: '/part-time-jobs', Icon: FaClock },
  { label: 'Internship jobs', to: '/internship-jobs', Icon: FaGraduationCap },
  { label: 'Contract jobs', to: '/jobs?job_type=contract', Icon: FaFileSignature },
  { label: 'Fresher jobs', to: '/jobs-for-freshers', Icon: FaUserGraduate },
  { label: 'Work from home jobs', to: '/work-from-home-jobs', Icon: FaHome },
  { label: 'Hybrid jobs', to: '/hybrid-jobs', Icon: FaLaptopHouse },
  { label: 'Night shift jobs', to: '/jobs?work_shift=night', Icon: FaMoon },
];

const seoIndustries = landingData.INDUSTRIES || [];
const seoCities = landingData.CITIES || [];

const aiTools = [
  { name: 'Resume Score Checker', path: '/resume-score', Icon: FaFileAlt },
  { name: 'Mock Interview', path: '/mock-interview', Icon: FaMicrophone },
  { name: 'Interview Q&A', path: '/interview-questions', Icon: FaQuestionCircle },
];

const ICON_RULES = [
  [/information technology|software|\bit\b/i, FaLaptopCode],
  [/health|hospital|doctor|medical/i, FaStethoscope],
  [/bank|financ/i, FaUniversity],
  [/digital marketing|marketing/i, FaBullhorn],
  [/sales|business development/i, FaChartLine],
  [/bpo|customer|support/i, FaHeadset],
  [/manufactur/i, FaIndustry],
  [/logistic|supply/i, FaTruck],
  [/hospitality|retail|hotel/i, FaHotel],
  [/educat|admin/i, FaGraduationCap],
  [/human resource|\bhr\b/i, FaUsers],
  [/construction|engineer/i, FaHardHat],
];

function NavIcon({ name, kind }) {
  const Icon = kind === 'location'
    ? FaMapMarkerAlt
    : (ICON_RULES.find(([re]) => re.test(name)) || [null, FaBriefcase])[1];
  return <Icon className='shrink-0 text-[13px] text-[#7047FF]' aria-hidden='true' />;
}

function DropMenu({ id, label, to, items, openMenu, setOpenMenu, narrow = false }) {
  return (
    <div
      className='relative'
      onMouseEnter={() => setOpenMenu(id)}
      onMouseLeave={() => setOpenMenu(null)}
    >
      <Link to={to} onClick={() => setOpenMenu(null)} className='hover:text-white transition flex items-center gap-1'>
        {label} <span className='text-[10px]'>▾</span>
      </Link>
      <div className={`${openMenu === id ? 'block' : 'hidden'} absolute left-0 top-full pt-3 z-50`}>
        <div
          onClick={() => setOpenMenu(null)}
          className={`bg-white rounded-2xl shadow-xl border border-gray-100 p-5 ${narrow ? 'w-[260px]' : 'w-[520px] grid-cols-2'} max-w-[calc(100vw-2rem)] max-h-[70vh] overflow-y-auto grid gap-x-6 text-gray-700 whitespace-normal`}
        >
          {items.map((it) => (
            <Link
              key={it.path}
              to={it.path}
              className='flex items-center gap-2.5 py-1.5 text-sm hover:text-[#7047FF] transition'
              title={it.name}
            >
              {it.Icon
                ? <it.Icon className='shrink-0 text-[13px] text-[#7047FF]' aria-hidden='true' />
                : <NavIcon name={it.name} kind={id} />}
              <span className='truncate'>{it.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

const companyCollections = [
  { label: 'Top companies', to: '/companies?collection=top' },
  { label: 'Featured companies', to: '/companies?collection=featured' },
  { label: 'Verified companies', to: '/companies?collection=verified' },
  { label: 'Actively hiring', to: '/companies?collection=hiring' },
];

function Navbar({ user }) {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
const [mobileCompaniesOpen, setMobileCompaniesOpen] = useState(false);
const [mobileJobsOpen, setMobileJobsOpen] = useState(false); 
const [mobileSeoOpen, setMobileSeoOpen] = useState(null); // 'industry' | 'location' | null 
const [openMenu, setOpenMenu] = useState(null); // 'jobs' | 'companies' | null



  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api
      .get('/job-categories')
      .then((res) => setCategories(res.data || []))
      .catch(() => setCategories([]));
  }, []);
  
  const closeMobileMenu = () => setMobileMenuOpen(false);

  const isImpersonating = !!localStorage.getItem('admin_token');

const returnToAdmin = () => {
  localStorage.setItem('token', localStorage.getItem('admin_token'));
  localStorage.setItem('user', localStorage.getItem('admin_user'));
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
  window.location.href = '/admin';
};

    // true for logged-in job seekers / agents etc. (not employer/admin)
  const isAgent = user?.role === 'agent';
const isMember = !!user && !isAgent && user?.role !== 'employer' && user?.role !== 'admin';

 
  const guestLinks = [
  { label: 'AI Job Matching', to: '/ai-job-matching' },
  { label: 'Why PlanB Jobs', to: '/why-planb-jobs' },
  { label: 'For Employers', to: '/employers' },
];

  const careerTools = [
    { label: 'Resume score checker', to: '/resume-score' },
    { label: 'Resume preview / PDF', to: '/resume-builder' },
    { label: 'Interview Q&A', to: '/interview-questions' },
    { label: 'AI mock interview', to: '/mock-interview' },
  ];

  const goToSection = (id) => {
    closeMobileMenu();
    if (window.location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${id}`);
    }
  };

  const handleLogout = async () => {
    try {
      await api.post('/logout');
    } catch (error) {
      // Ignore API error and clear local storage
    }

   localStorage.removeItem('token');
localStorage.removeItem('user');
localStorage.removeItem('admin_token');
localStorage.removeItem('admin_user');
closeMobileMenu();
navigate('/login');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    closeMobileMenu();
    if (search.trim()) {
      navigate(`/jobs?search=${encodeURIComponent(search)}`);
    } else {
      navigate('/jobs');
    }
  };

  return (
    <nav className='bg-[#17142A] border-b border-white/10 shadow-sm sticky top-0 z-50 print:hidden'>
      <style>{`
        @keyframes nav-fade { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: none; } }
        @keyframes menu-in { from { opacity: 0; transform: translateY(10px) scale(.98); } to { opacity: 1; transform: none; } }
        @keyframes nav-line { to { background-position: 200% 50%; } }
        @keyframes nav-pulse { 0% { box-shadow: 0 0 0 0 rgba(199,244,100,.55); } 100% { box-shadow: 0 0 0 12px rgba(199,244,100,0); } }
        @keyframes news-wiggle { 0%,100% { transform: rotate(0); } 20% { transform: rotate(-14deg); } 40% { transform: rotate(10deg); } 60% { transform: rotate(-6deg); } 80% { transform: rotate(4deg); } }
        @keyframes spin-in { from { transform: rotate(-90deg); opacity: 0; } to { transform: none; opacity: 1; } }

        .nav-line { background: linear-gradient(90deg,#7C3AED,#DB2777,#C7F464,#7C3AED); background-size: 200% 100%; animation: nav-line 6s linear infinite; }

        .nav-links > * { animation: nav-fade .35s cubic-bezier(.2,.8,.2,1) both; }
        .nav-links > *:nth-child(2) { animation-delay: .05s; }
        .nav-links > *:nth-child(3) { animation-delay: .1s; }
        .nav-links > *:nth-child(4) { animation-delay: .15s; }
        .nav-links > *:nth-child(5) { animation-delay: .2s; }
        .nav-links > *:nth-child(6) { animation-delay: .25s; }

        .nav-links > a, .nav-links > button, .nav-links > div > a, .nav-links > div > button { position: relative; padding: 6px 0; }
        .nav-links > a:not([href*="billing"])::after,
        .nav-links > button::after,
        .nav-links > div > a::after,
        .nav-links > div > button::after {
          content: ''; position: absolute; left: 0; bottom: 0; width: 100%; height: 2px; border-radius: 2px;
          background: linear-gradient(90deg,#C7F464,#DB2777);
          transform: scaleX(0); transform-origin: left; transition: transform .3s ease;
        }
        .nav-links > a:not([href*="billing"]):hover::after,
        .nav-links > button:hover::after,
        .nav-links > div > a:hover::after,
        .nav-links > div > button:hover::after { transform: scaleX(1); }

        .nav-links .relative > a > span, .nav-links .relative > button > span { display: inline-block; transition: transform .25s ease; }
        .nav-links .relative:hover > a > span, .nav-links .relative:hover > button > span { transform: rotate(180deg); }

        .nav-links div.absolute > div { animation: menu-in .25s cubic-bezier(.2,.8,.2,1) both; }
        .nav-links div.absolute a { transition: transform .2s ease, color .2s ease; }
        .nav-links div.absolute a:hover { transform: translateX(4px); }

        .nav-cta { animation: nav-pulse 2.4s ease-out infinite; }
        .news-link:hover svg { animation: news-wiggle .6s ease; }
        .menu-in { animation: menu-in .3s cubic-bezier(.2,.8,.2,1) both; }
        .menu-spin { animation: spin-in .25s ease-out both; }

        @media (prefers-reduced-motion: reduce) {
          .nav-links > *, .nav-links div.absolute > div, .nav-line, .nav-cta, .menu-in, .menu-spin, .news-link:hover svg { animation: none; }
        }
      `}</style>
      <div className='nav-line absolute bottom-0 left-0 h-[2px] w-full pointer-events-none' aria-hidden='true' />

  {isImpersonating && (
    <div className='bg-amber-100 text-amber-800 text-sm px-4 py-2 flex items-center justify-between'>
      <span>You are logged in as {user?.name || 'this user'} ({user?.role?.replace('_', ' ')}) – admin view.</span>
      <button onClick={returnToAdmin} className='font-semibold underline'>
        Return to Admin
      </button>
    </div>
  )}

  <div className='max-w-7xl mx-auto px-4 md:px-8 py-2 flex items-center justify-between gap-3 xl:gap-6'>

        {/* Left */}
        <div className='flex items-center gap-3 lg:gap-4 xl:gap-8'>
<Link
  to={!user ? '/' : user?.role === 'employer' ? '/employer/jobs' : user?.role === 'admin' ? '/admin' : isAgent ? '/agent/dashboard' : '/dashboard'}
  className='flex items-center'
  onClick={closeMobileMenu}
>
  <img
    src={planbLogo}
    alt="PlanB Jobs"
    className='h-10 md:h-12 w-32 md:w-32 lg:w-36 xl:w-48 object-contain object-left shrink-0 origin-left transition-transform duration-300 hover:scale-105'
  />
</Link>
          <div className='nav-links hidden md:flex items-center gap-3 xl:gap-5 text-sm xl:text-[15px] whitespace-nowrap text-white/85 font-medium'>

          

            {user?.role !== 'employer' && user?.role !== 'admin' && !isAgent && (
  <div
    className='relative'
    onMouseEnter={() => setOpenMenu('jobs')}
    onMouseLeave={() => setOpenMenu(null)}
  >
    <Link to='/jobs' onClick={() => setOpenMenu(null)} className='hover:text-white transition flex items-center gap-1'>
      {user ? 'Jobs' : 'Find Jobs'} <span className='text-[10px]'>▾</span>
    </Link>

    <div className={`${openMenu === 'jobs' ? 'block' : 'hidden'} absolute left-0 top-full pt-3 z-50`}>
  <div
    onClick={() => setOpenMenu(null)}
    className='bg-white rounded-2xl shadow-xl border border-gray-100 p-6 w-[260px] max-w-[calc(100vw-2rem)] text-gray-700'
  >

        

        <div className='border-l border-gray-100 pl-6'>
          <p className='text-sm font-bold text-[#252438] mb-3'>Jobs in demand</p>
         {jobsInDemand.map((j) => (
  <Link key={j.label} to={j.to}
    className='flex items-center gap-2.5 py-1.5 text-sm hover:text-[#7047FF] transition'>
    <j.Icon className='shrink-0 text-[13px] text-[#7047FF]' aria-hidden='true' />
    {j.label}
  </Link>
))}
        </div>

        
      </div>
    </div>
  </div>
)}


            {!user && (
  <>
    {guestLinks.map((l) => (
      <Fragment key={l.to}>
        {l.to === '/ai-job-matching' && (
          <>
            <DropMenu id='industry' label='Industry' to='/jobs-by-industry' items={seoIndustries} openMenu={openMenu} setOpenMenu={setOpenMenu} />
            <DropMenu id='location' label='Location' to='/jobs-by-location' items={seoCities} openMenu={openMenu} setOpenMenu={setOpenMenu} />
          </>
        )}
        {l.to === '/ai-job-matching' ? (
          <DropMenu id='ai' label={l.label} to={l.to} items={aiTools} narrow openMenu={openMenu} setOpenMenu={setOpenMenu} />
        ) : l.home || l.to === '/employers' ? (
          <Link
            to={l.to}
            className='nav-cta bg-[#C7F464] text-[#17142A] text-sm font-semibold !px-4 !py-1.5 rounded-lg hover:shadow-md hover:-translate-y-0.5 transition'
          >
            {l.label}
          </Link>
        ) : (
          <Link to={l.to} className='hover:text-white transition'>
            {l.label}
          </Link>
        )}
      </Fragment>
    ))}
  </>
)}

            {user?.role === 'job_seeker' && (
              <>
                <Link to='/jobs' className='hover:text-white transition'>
                  Find Jobs
                </Link>

                <Link
                  to='/my-applications'
                  className='hover:text-white transition'
                >
                  Applications
                </Link>

                <Link
                  to='/profile'
                  className='hover:text-white transition'
                >
                  Profile
                </Link>
              </>
            )}

            {isMember && (
              <>
                <div className='relative group'>
                  <button type='button' className='hover:text-white transition flex items-center gap-1'>
                    Services <span className='text-[10px]'>▾</span>
                  </button>
                  <div className='hidden group-hover:block group-focus-within:block absolute left-0 top-full pt-3 z-50'>
                    <div className='bg-white rounded-xl shadow-xl border border-gray-100 p-3 w-64 text-gray-700'>
                      <p className='px-3 py-1 text-xs font-bold text-[#7047FF] uppercase tracking-wide'>AI career tools</p>
                      {careerTools.map((t) => (
                        <Link
                          key={t.label}
                          to={t.to}
                          className='block px-3 py-2 rounded-lg text-sm hover:bg-[#F5F0FA] hover:text-[#7047FF] transition'
                        >
                          {t.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            )}

            {isMember && (
  <div
    className='relative'
    onMouseEnter={() => setOpenMenu('companies')}
    onMouseLeave={() => setOpenMenu(null)}
  >
    <button type='button' className='hover:text-white transition flex items-center gap-1'>
      Companies <span className='text-[10px]'>▾</span>
    </button>

    <div className={`${openMenu === 'companies' ? 'block' : 'hidden'} absolute right-0 top-full pt-3 z-50`}>
  <div
    onClick={() => setOpenMenu(null)}
    className='bg-white rounded-2xl shadow-xl border border-gray-100 p-6 w-[720px] max-w-[calc(100vw-2rem)] grid grid-cols-[1.4fr_1fr_1fr] gap-6 text-gray-700'
  >

        {/* Categories */}
        <div>
          <p className='text-sm font-bold text-[#252438] mb-3'>Explore categories</p>
        {categories.slice(0, 8).map((c) => (
  <Link
    key={c.slug}
    to={`/jobs?department=${encodeURIComponent(c.slug)}`}
    className='block py-1.5 text-sm hover:text-[#7047FF] transition'
  >
    {c.name}
  </Link>
))}
<Link to='/jobs' className='block py-1.5 text-sm font-semibold text-[#7047FF]'>
  View all →
</Link>
        </div>

        {/* Locations */}
        <div className='border-l border-gray-100 pl-6'>
          <p className='text-sm font-bold text-[#252438] mb-3'>Explore by location</p>
          {companyLocations.map((l) => (
      <Link
  key={l.label}
  to={`/jobs?location=${encodeURIComponent(l.full)}`}
  reloadDocument
  className='block py-1.5 text-sm hover:text-[#7047FF] transition'
>
  Jobs in {l.label}
</Link>
          ))}
        </div>

        {/* Collections */}
        <div className='border-l border-gray-100 pl-6'>
          <p className='text-sm font-bold text-[#252438] mb-3'>Explore collections</p>
          {companyCollections.map((c) => (
            <Link
              key={c.label}
              to={c.to}
              className='block py-1.5 text-sm hover:text-[#7047FF] transition'
            >
              {c.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  </div>
)}

        {user?.role === 'employer' && (
  <>
    <Link
      to='/employer/dashboard'
      className='hover:text-white transition'
    >
      Dashboard
    </Link>

    <Link
      to='/company-profile'
      className='hover:text-white transition'
    >
       Profile
    </Link>

    {!user?.employer_id && (
      <Link
        to='/employer/team'
        className='hover:text-white transition'
      >
        Team
      </Link>
    )}


    <Link
      to='/employer/settings/billing'
      className='nav-cta bg-[#C7F464] text-[#17142A] text-sm font-semibold px-4 py-1.5 rounded-lg hover:shadow-md hover:-translate-y-0.5 transition'
    >
      Buy Plan
    </Link>
  </>

)}

{isAgent && (
  <>
    <Link to='/agent/dashboard' className='hover:text-white transition'>Dashboard</Link>
    <Link to='/agent/candidates' className='hover:text-white transition'>My Candidates</Link>
  </>
)}
            {user?.role === 'admin' && (
              <Link to='/admin' className='hover:text-white transition'>
                Admin Panel
              </Link>
            )}

            {/* Browse Jobs only shown here for non-job-seekers (employer,
                admin, or logged-out) since job seekers already have
                "Find Jobs" above pointing to the same /jobs page. This
                removes the duplicate link that used to render twice
                for job seekers. */}
          {isMember && user?.role !== 'job_seeker' && (
              <Link
                to='/jobs'
                className='hover:text-white transition'
              >
                Browse Jobs
              </Link>
            )}
          </div>
        </div>

        

        {/* Right */}
<div className='flex items-center gap-2 md:gap-4'>
  <Link
    to='/news'
    onClick={closeMobileMenu}
    title='Jobs news'
    aria-label='Jobs news'
    className='news-link flex flex-col items-center leading-none text-white/90 hover:text-white hover:bg-white/10 px-2 py-1.5 rounded-lg transition'
  >
    <FaNewspaper className='text-lg' />
    <span className='mt-1 text-[10px] font-semibold tracking-wide'>News</span>
  </Link>

  {user && <NotificationBell />}
  {user?.role === 'employer' && (
  <div className='[&_*]:!text-white [&_*]:!border-white/70 [&_a]:!bg-white/15 [&_button]:!bg-white/15 [&_div]:!bg-transparent [&_a]:transition [&_button]:transition [&_a:hover]:!bg-white [&_button:hover]:!bg-white [&_a:hover]:!text-[#7047FF] [&_button:hover]:!text-[#7047FF] [&_a:hover_*]:!text-[#7047FF] [&_button:hover_*]:!text-[#7047FF]'>
    <CreditsHeader />
  </div>
)}
  <InstallAppButton className='hidden 2xl:flex' />
  {/* Desktop profile / auth actions */}
  <div className='hidden md:flex items-center gap-2 xl:gap-4 shrink-0'>
            {user ? (
              <>
                <Link
                  to={
                    user?.role === 'employer'
                      ? '/company-profile'
                      : user?.role === 'admin'
                      ? '/admin'
                      : isAgent ? '/agent/profile' : '/profile'
                  }
                  className='flex items-center gap-2 hover:bg-white/10 p-2 rounded-lg transition'
                >
                  {user?.role === 'employer' ? (
  user?.company_logo ? (
    <img
      src={user.company_logo.startsWith('http') ? user.company_logo : `${BACKEND_URL}/storage/${user.company_logo}`}
      alt={user?.name || 'Company'}
      className='w-10 h-10 rounded-full object-contain bg-white p-0.5'
    />
  ) : (
    <div className='w-9 h-9 rounded-full bg-white/20 text-white flex items-center justify-center'>
      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round' className='w-5 h-5'>
        <rect x='4' y='3' width='16' height='18' rx='1' />
        <path d='M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1' />
        <path d='M9 21v-4h6v4' />
      </svg>
    </div>
  )
) : user?.profile_photo_path ? (
  <img
    src={`${BACKEND_URL}/storage/${user.profile_photo_path}`}
    alt={user?.name || 'User'}
    className='w-9 h-9 rounded-full object-cover'
  />
) : (
  <FaUserCircle className='text-3xl text-white' />
)}
                  <div className='hidden lg:block text-left'>
                    <p className='font-medium text-sm text-white'>
                      {user?.name || 'User'}
                    </p>
                    <p className='text-xs text-white/70 capitalize'>
                      {user?.role?.replace('_', ' ') || 'Guest'}
                    </p>
                  </div>
                </Link>

                <button
                  onClick={handleLogout}
                  className='bg-white text-[#7047FF] px-4 py-2 rounded-lg font-medium hover:bg-[#B6E84A] transition whitespace-nowrap'
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to='/login'
                  className='text-sm font-medium text-white/85 hover:text-white px-3 py-2 whitespace-nowrap'
                >
                  Login
                </Link>
                <Link
                  to='/register'
                  className='nav-cta bg-white text-[#7047FF] px-4 py-2 rounded-lg font-medium hover:bg-white/90 hover:-translate-y-0.5 hover:shadow-lg transition whitespace-nowrap'
                >
                  Register
                </Link>
              </>
            )}
          </div>

          {/* Mobile hamburger toggle */}
          <button
            onClick={() => setMobileMenuOpen((open) => !open)}
            className='md:hidden text-2xl text-white p-2'
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          >
            <span key={String(mobileMenuOpen)} className='block menu-spin'>
              {mobileMenuOpen ? <FaTimes /> : <FaBars />}
            </span>
          </button>
        </div>
      </div>

      {/* Mobile dropdown panel */}
      {mobileMenuOpen && (
        <div className='menu-in md:hidden border-t bg-white px-4 py-4 space-y-4'>
          {/* Search */}
          <form
            onSubmit={handleSearch}
            className='flex items-center bg-purple-50 rounded-full px-4 py-2'
          >
            <FaSearch className='text-gray-500' />
            <input
              type='text'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder='Search jobs, companies, skills...'
              className='bg-transparent outline-none px-3 w-full text-sm'
            />
          </form>

             <InstallAppButton className='w-full justify-center' />

          {/* Nav links */}
          <div className='flex flex-col gap-1 text-gray-700 font-medium'>
           

            {user?.role !== 'employer' && user?.role !== 'admin' && (
  <>
    <button
      type='button'
      onClick={() => setMobileJobsOpen((o) => !o)}
      className='py-2 text-left flex items-center justify-between hover:text-[#9333EA] transition'
    >
      {user ? 'Jobs' : 'Find Jobs'} <span className='text-xs'>{mobileJobsOpen ? '▴' : '▾'}</span>
    </button>

    {mobileJobsOpen && (
      <div className='pl-3 pb-2 space-y-1'>
        <Link to='/jobs' onClick={closeMobileMenu} className='block py-1.5 text-sm font-semibold text-[#7047FF]'>
          All jobs
        </Link>
        <p className='pt-1 text-xs font-bold text-[#7047FF] uppercase tracking-wide'>Popular categories</p>
        {categories.slice(0, 6).map((c) => (
          <Link key={c.slug} to={`/jobs?department=${encodeURIComponent(c.slug)}`}
            onClick={closeMobileMenu} className='block py-1.5 text-sm hover:text-[#9333EA]'>
            {c.name}
          </Link>
        ))}
        <p className='pt-2 text-xs font-bold text-[#7047FF] uppercase tracking-wide'>Jobs in demand</p>
       {jobsInDemand.map((j) => (
  <Link key={j.label} to={j.to} onClick={closeMobileMenu}
    className='flex items-center gap-2.5 py-1.5 text-sm hover:text-[#9333EA]'>
    <j.Icon className='shrink-0 text-[13px] text-[#7047FF]' aria-hidden='true' />
    {j.label}
  </Link>
))}
        <p className='pt-2 text-xs font-bold text-[#7047FF] uppercase tracking-wide'>Jobs by location</p>
        {companyLocations.map((l) => (
          <Link key={l.label} to={`/jobs?location=${encodeURIComponent(l.full)}`}
            onClick={closeMobileMenu} className='block py-1.5 text-sm hover:text-[#9333EA]'>
            Jobs in {l.label}
          </Link>
        ))}
      </div>
    )}
  </>
)}


            {!user && (
  <>
    {guestLinks.map((l) => (
      <Fragment key={l.to}>
        {l.to === '/ai-job-matching' && (
          <>
            {[
              ['industry', 'Industry', seoIndustries, '/jobs-by-industry'],
              ['location', 'Location', seoCities, '/jobs-by-location'],
            ].map(([id, label, items, to]) => (
              <Fragment key={id}>
                <button
                  type='button'
                  onClick={() => setMobileSeoOpen((o) => (o === id ? null : id))}
                  className='py-2 text-left flex items-center justify-between hover:text-[#9333EA] transition'
                >
                  {label} <span className='text-xs'>{mobileSeoOpen === id ? '▴' : '▾'}</span>
                </button>
                {mobileSeoOpen === id && (
                  <div className='pl-3 pb-2 space-y-1'>
                    <Link to={to} onClick={closeMobileMenu} className='block py-1.5 text-sm font-semibold text-[#7047FF]'>
                      View all {label.toLowerCase()} pages
                    </Link>
                    {items.map((it) => (
                      <Link key={it.path} to={it.path} onClick={closeMobileMenu} className='flex items-center gap-2.5 py-1.5 text-sm hover:text-[#9333EA]'>
                        <NavIcon name={it.name} kind={id} />
                        {it.name}
                      </Link>
                    ))}
                  </div>
                )}
              </Fragment>
            ))}
          </>
        )}
        {l.to === '/ai-job-matching' ? (
          <>
            <button
              type='button'
              onClick={() => setMobileSeoOpen((o) => (o === 'ai' ? null : 'ai'))}
              className='py-2 text-left flex items-center justify-between hover:text-[#9333EA] transition'
            >
              {l.label} <span className='text-xs'>{mobileSeoOpen === 'ai' ? '▴' : '▾'}</span>
            </button>
            {mobileSeoOpen === 'ai' && (
              <div className='pl-3 pb-2 space-y-1'>
                <Link to={l.to} onClick={closeMobileMenu} className='block py-1.5 text-sm font-semibold text-[#7047FF]'>
                  About AI job matching
                </Link>
                {aiTools.map((it) => (
                  <Link key={it.path} to={it.path} onClick={closeMobileMenu} className='flex items-center gap-2.5 py-1.5 text-sm hover:text-[#9333EA]'>
                    <it.Icon className='shrink-0 text-[13px] text-[#7047FF]' aria-hidden='true' />
                    {it.name}
                  </Link>
                ))}
              </div>
            )}
          </>
        ) : l.home || l.to === '/employers' ? (
          <Link to={l.to} onClick={closeMobileMenu} className='py-2'>
            <span className='inline-block bg-[#7047FF] text-white text-sm font-semibold px-4 py-1.5 rounded-lg'>
              {l.label}
            </span>
          </Link>
        ) : (
          <Link to={l.to} onClick={closeMobileMenu} className='py-2 hover:text-[#9333EA] transition'>
            {l.label}
          </Link>
        )}
      </Fragment>
    ))}
  </>
)}

            {user?.role === 'job_seeker' && (
              <>
                <Link to='/jobs' onClick={closeMobileMenu} className='py-2 hover:text-[#9333EA] transition'>
                  Find Jobs
                </Link>
                <Link to='/my-applications' onClick={closeMobileMenu} className='py-2 hover:text-[#9333EA] transition'>
                  Applications
                </Link>
                <Link to='/profile' onClick={closeMobileMenu} className='py-2 hover:text-[#9333EA] transition'>
                  Profile
                </Link>
              </>
            )}

            {isMember && (
              <>
                <p className='pt-2 text-xs font-bold text-[#7047FF] uppercase tracking-wide'>AI career tools</p>
                {careerTools.map((t) => (
                  <Link key={t.label} to={t.to} onClick={closeMobileMenu} className='py-2 pl-3 hover:text-[#9333EA] transition'>
                    {t.label}
                  </Link>
                ))}
              </>
            )}

            {isMember && (
  <>
    <button
      type='button'
      onClick={() => setMobileCompaniesOpen((o) => !o)}
      className='py-2 text-left flex items-center justify-between hover:text-[#9333EA] transition'
    >
      Companies <span className='text-xs'>{mobileCompaniesOpen ? '▴' : '▾'}</span>
    </button>

    {mobileCompaniesOpen && (
      <div className='pl-3 pb-2 space-y-1'>
        <p className='pt-1 text-xs font-bold text-[#7047FF] uppercase tracking-wide'>Categories</p>
       {categories.slice(0, 8).map((c) => (
  <Link key={c.slug} to={`/jobs?department=${encodeURIComponent(c.slug)}`}
    onClick={closeMobileMenu} className='block py-1.5 text-sm hover:text-[#9333EA]'>
    {c.name}
  </Link>
))}
        <p className='pt-2 text-xs font-bold text-[#7047FF] uppercase tracking-wide'>Locations</p>
        {companyLocations.map((l) => (
       <Link key={l.label} to={`/jobs?location=${encodeURIComponent(l.full)}`}
  reloadDocument onClick={closeMobileMenu} className='block py-1.5 text-sm hover:text-[#9333EA]'>
  Jobs in {l.label}
</Link>
        ))}
        <p className='pt-2 text-xs font-bold text-[#7047FF] uppercase tracking-wide'>Collections</p>
        {companyCollections.map((c) => (
          <Link key={c.label} to={c.to} onClick={closeMobileMenu}
            className='block py-1.5 text-sm hover:text-[#9333EA]'>
            {c.label}
          </Link>
        ))}
      </div>
    )}
  </>
)}

  {user?.role === 'employer' && (
  <>
    <Link to='/employer/dashboard' onClick={closeMobileMenu} className='py-2 hover:text-[#9333EA] transition'>
      Dashboard
    </Link>
    <Link to='/company-profile' onClick={closeMobileMenu} className='py-2 hover:text-[#9333EA] transition'>
      Profile
    </Link>
    {!user?.employer_id && (
      <Link to='/employer/team' onClick={closeMobileMenu} className='py-2 hover:text-[#9333EA] transition'>
        Team
      </Link>
    )}
    <Link to='/employer/settings/billing' onClick={closeMobileMenu} className='py-2'>
      <span className='inline-block bg-[#7047FF] text-white text-sm font-semibold px-4 py-1.5 rounded-lg'>
        Buy Plan
      </span>
    </Link>
  </>
)}
            {user?.role === 'admin' && (
              <Link to='/admin' onClick={closeMobileMenu} className='py-2 hover:text-[#9333EA] transition'>
                Admin Panel
              </Link>
            )}

            {isMember && user?.role !== 'job_seeker' && (
  <Link to='/jobs' onClick={closeMobileMenu} className='py-2 hover:text-[#9333EA] transition'>
    Browse Jobs
  </Link>
)}

            <Link to='/news' onClick={closeMobileMenu} className='py-2 hover:text-[#9333EA] transition'>
              Jobs News
            </Link>
          </div>

          <hr />

          {/* Profile / auth actions */}
          {user ? (
            <div className='space-y-3'>
              <Link
                to={
                  user?.role === 'employer'
                    ? '/company-profile'
                    : user?.role === 'admin'
                    ? '/admin'
                    : '/profile'
                }
                onClick={closeMobileMenu}
                className='flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 transition'
              >
               {user?.role === 'employer' ? (
  user?.company_logo ? (
    <img
      src={`${BACKEND_URL}/storage/${user.company_logo}`}
      alt={user?.name || 'Company'}
      className='w-9 h-9 rounded-full object-cover'
    />
  ) : (
    <div className='w-9 h-9 rounded-full bg-gray-100 text-gray-400 flex items-center justify-center'>
      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round' className='w-5 h-5'>
        <rect x='4' y='3' width='16' height='18' rx='1' />
        <path d='M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1' />
        <path d='M9 21v-4h6v4' />
      </svg>
    </div>
  )
) : user?.profile_photo_path ? (
  <img
    src={`${BACKEND_URL}/storage/${user.profile_photo_path}`}
    alt={user?.name || 'User'}
    className='w-9 h-9 rounded-full object-cover'
  />
) : (
  <FaUserCircle className='text-3xl text-[#9333EA]' />
)}
                <div className='text-left'>
                  <p className='font-medium text-sm text-[#252438]'>
                    {user?.name || 'User'}
                  </p>
                  <p className='text-xs text-gray-500 capitalize'>
                    {user?.role?.replace('_', ' ') || 'Guest'}
                  </p>
                </div>
              </Link>

              <button
                onClick={handleLogout}
                className='w-full bg-[#7047FF] text-white px-4 py-2 rounded-lg font-medium hover:opacity-90 transition'
              >
                Logout
              </button>
            </div>
          ) : (
            <div className='flex flex-col gap-2'>
              <Link
                to='/login'
                onClick={closeMobileMenu}
                className='text-sm font-medium text-gray-700 hover:text-[#7047FF] px-3 py-2 text-center border border-gray-200 rounded-lg'
              >
                Login
              </Link>
              <Link
                to='/register'
                onClick={closeMobileMenu}
                className='bg-[#F59E0B] text-white px-4 py-2 rounded-lg font-medium hover:opacity-90 transition text-center'
              >
                Register
              </Link>
            </div>
          )}
        </div>
      )}
    </nav>
  );
}

export default Navbar;